"use strict";

const style = require("!!css-loader!./style/index.css").default;


module.exports =`
    <style>${style}</style>
    <div class="datepicker-container">
<!--    <input type="text" class="datepicker-input" placeholder="Select date..." readonly>-->
    
   <div class="swiftref-input">
  
        <div style="display: flex; align-items: center;">
            <label></label>
        </div>
        <div class="input-container">
            <input>
            <swiftref-icon kind="calendar"></swiftref-icon>
        </div>
        <swiftref-message></swiftref-message>
    </div>   
    
<div class="datepicker-calendar">
    <div class="calendar-header">
        <div>
            <button class="btn prev-year" aria-label="Previous Year" title="Previous Year"><swiftref-icon kind="double-arrow-left-green"></swiftref-icon></button>
            <button class="btn prev-month" aria-label="Previous Month" title="Previous Month"><swiftref-icon kind="arrow-left-green"></swiftref-icon></button>
        </div>
        <p class="month-year p2"></p>
        <div>
            <button class="btn next-month" aria-label="Next Month" title="Next Month"><swiftref-icon kind="arrow-right-green"></swiftref-icon></button>
            <button class="btn next-year" aria-label="Next Year" title="Next Year"><swiftref-icon kind="double-arrow-right-green"></swiftref-icon></button>
        </div>
    </div>
      
      <div class="calendar-body">
        <div class="weekdays">
          <span>Mo</span>
          <span>Tu</span>
          <span>We</span>
          <span>Th</span>
          <span>Fr</span>
          <span>Sa</span>
          <span>Su</span>
        </div>
        
        <div class="days-grid"></div>
      </div>
      
      <div class="time-container" style="display: none;">
         <swiftref-time-input class="time-input" include-seconds use-24-hour-format kind="compact" headless></swiftref-time-input>
      </div>
      
      <div class="calendar-footer">
        <swiftref-button kind="tertiary" class="today-btn">Today</swiftref-button>
        <div style="display: flex; gap: 16px;">
            <swiftref-button kind="secondary" class="clear-btn">Clear</swiftref-button>
            <swiftref-button class="done-btn">Done</swiftref-button>
        </div>
      </div>
    </div>
    </div>
`;
